// extracted by mini-css-extract-plugin
export var active = "_ie-7";
export var blink = "_ie-8";
export var dropDownSelector = "_ie-4";
export var dropDownWrapper = "_ie-3";
export var fakeCursor = "_ie-6";
export var fontSizeButton = "_ie-9";
export var formQuillEditor = "_ie-0";
export var pressed = "_ie-a";
export var qlBlank = "_ie-1";
export var textFormattingToolbar = "_ie-2";
export var textToolbarOption = "_ie-5";